import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param publishedClient
 * @param query If `undefined`, no data is fetched
 * @param paging
 * @returns If no result, `connection` is `undefined`. If there are no matches, `connection` is `null`
 */
export function usePublishedEntities(publishedClient, query, paging) {
    const fetcher = useCallback(([_action, query, paging]) => fetchEntities(publishedClient, query, paging), [publishedClient]);
    const { data, error } = useSWR(query ? CACHE_KEYS.publishedEntities(query, paging) : null, fetcher);
    // useDebugLogChangedValues('usePublishedEntities updated values', { publishedClient, query, paging, data, error, });
    return { connection: data, connectionError: error };
}
async function fetchEntities(publishedClient, query, paging) {
    const result = await publishedClient.getEntities(query, paging);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=usePublishedEntities.js.map